<template>
  <VView class="quiz-instructions" back-button-to="/menu" header="Quiz wiedzy">
    <VText small>Czy jesteś prawdziwym fanem Przyjaciół? Sprawdź swoją wiedzę na temat ulubionych bohaterów, kultowych scen i najśmieszniejszych momentów z tego serialu! </VText>
    <VText small>Quiz składa się z 10 pytań zamkniętych, a każde pytanie ma tylko  jedną poprawną odpowiedź.</VText>
    <VText small>Przekonaj się, ile pamiętasz z przygód Rachel, Rossa, Moniki, Chandlera, Phoebe i Joeya! </VText>
    <VText small>Powodzenia!</VText>

    <VBlock max-width="460px">
      <transition name="bounceUp" appear>
        <VButton to="/quiz/game">Rozpocznij quiz</VButton>
      </transition>
    </VBlock>
  </VView>
</template>

<script>
export default {
  name: 'QuizInstructions',
};
</script>

<style lang="scss" scoped>
.quiz-instructions {}
</style>
